import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAbout,
  fetchBotDirectory,
  fetchEventCoverage,
  fetchGlossaryTerms,
  fetchPartners,
  fetchPrivacyPolicy,
  fetchSubscriptions,
  fetchTeamLeaders,
  fetchToolsTrade,
  transformLessonData,
  fetchCirriculumOverview,
} from "../action/moreAction";

const initialState = {
  botList: [],
  aboutData: {},
  isLoading1: false,
  partnersList: [],
  subscriptionsList: [],
  privacyPolicy: {},
  glossaryterms: {},
  toolsTradeList: [],
  teamLeadersList: [],
  eventCoverageList: [],
  curriculumOverview: {}
};

const moreSlice = createSlice({
  name: "more",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //""fetch-tools-trade""
    builder.addCase(fetchToolsTrade.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.toolsTradeList = data.map((item) => ({
        ...item,
        title: item?.tools_trade_title ?? "",
        text: item?.tools_trade_description ?? "",
        image: item?.tools_trade_image ?? "",
      }));
      state.isLoading1 = false;
    });
    builder.addCase(fetchToolsTrade.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchToolsTrade.rejected, (state, action) => {
      state.isLoading1 = false;
    });

    //"fetch-event-coverage"
    builder.addCase(fetchEventCoverage.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.eventCoverageList = transformLessonData(data);
      state.isLoading1 = false;
    });
    builder.addCase(fetchEventCoverage.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchEventCoverage.rejected, (state, action) => {
      state.isLoading1 = false;
    });

    // fetch-partners
    builder.addCase(fetchPartners.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.partnersList = data ?? {};
      state.isLoading1 = false;
    });
    builder.addCase(fetchPartners.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchPartners.rejected, (state, action) => {
      state.isLoading1 = false;
    });
    // fetch-team-leaders
    builder.addCase(fetchTeamLeaders.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.teamLeadersList = data ?? {};
      state.isLoading1 = false;
    });
    builder.addCase(fetchTeamLeaders.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchTeamLeaders.rejected, (state, action) => {
      state.isLoading1 = false;
    });
    // fetch-glossary-terms
    builder.addCase(fetchGlossaryTerms.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.glossaryterms = data ?? {};
      state.isLoading1 = false;
    });
    builder.addCase(fetchGlossaryTerms.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchGlossaryTerms.rejected, (state, action) => {
      state.isLoading1 = false;
    });
    // fetch-privacy-policy
    builder.addCase(fetchPrivacyPolicy.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.privacyPolicy = data ?? {};
      state.isLoading1 = false;
    });
    builder.addCase(fetchPrivacyPolicy.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchPrivacyPolicy.rejected, (state, action) => {
      state.isLoading1 = false;
    });
    // fetch-about
    builder.addCase(fetchAbout.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.aboutData = data ?? {};
      state.isLoading1 = false;
    });
    builder.addCase(fetchAbout.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchAbout.rejected, (state, action) => {
      state.isLoading1 = false;
    });
    // fetch-bot-directory
    builder.addCase(fetchBotDirectory.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.botList = data ?? [];
      state.isLoading1 = false;
    });
    builder.addCase(fetchBotDirectory.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchBotDirectory.rejected, (state, action) => {
      state.isLoading1 = false;
    });
    // fetch-subscriptions
    builder.addCase(fetchSubscriptions.fulfilled, (state, action) => {
      const { subscriptions } = action?.payload || {};
      state.subscriptionsList = subscriptions ?? [];
      state.isLoading1 = false;
    });
    builder.addCase(fetchSubscriptions.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchSubscriptions.rejected, (state, action) => {
      state.isLoading1 = false;
    });
    // fetch-curriculum-overview
    // fetch-subscriptions
    builder.addCase(fetchCirriculumOverview.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.curriculumOverview = data ?? {};
      state.isLoading1 = false;
    });
    builder.addCase(fetchCirriculumOverview.pending, (state, action) => {
      state.isLoading1 = true;
    });
    builder.addCase(fetchCirriculumOverview.rejected, (state, action) => {
      state.isLoading1 = false;
    });
  },
});

export default moreSlice.reducer;
